(function() {
  var async,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  async = App.load('bower::async/lib/async');

  exports.JsDbLoader = (function() {
    function JsDbLoader(registry, instances) {
      this.registry = registry != null ? registry : {};
      this.instances = instances != null ? instances : {};
      this.getDbInstance = bind(this.getDbInstance, this);
      this._initializeDb = bind(this._initializeDb, this);
      void 0;
    }


    /*
     * Register a new JsDB DB class
     */

    JsDbLoader.prototype.register = function(name, dbclass) {
      return this.registry[name] = dbclass;
    };


    /*
     * Load data for multiple DBs. For instance, say I have a 'hybrids' and a 'treatments'
     * DB registered. I could pass in:
     *  {
     *       'hybrids': [(list of records...)]
     *       'treatments': [(list of records...)]
     *  }
     *
     * And both would be populated
     */

    JsDbLoader.prototype.load = function(dbData, callback) {
      var data, dbs, name, pushRecord;
      if (callback == null) {
        callback = function() {
          return void 0;
        };
      }
      dbs = [];
      pushRecord = (function(_this) {
        return function(name, data) {
          if (_this.exists(name)) {
            return dbs.push({
              instance: _this.getDbInstance(name),
              records: data
            });
          }
        };
      })(this);
      for (name in dbData) {
        data = dbData[name];
        pushRecord(name, data);
      }
      if (dbs.length === 0) {
        return callback({});
      }
      return async.map(dbs, this._initializeDb, callback);
    };


    /*
     * Same as `load()`, but it reads the `jsdb` component
     * of a JSONResponse and populates the DBs
     */

    JsDbLoader.prototype.loadJsonResponse = function(response, callback) {
      if (callback == null) {
        callback = function() {
          return void 0;
        };
      }
      if (response.jsdb == null) {
        return callback({});
      }
      return this.load(response.jsdb, callback);
    };

    JsDbLoader.prototype._initializeDb = function(dbinfo, callback) {
      return dbinfo.instance.initialize(dbinfo.records, (function(_this) {
        return function(err, result) {
          return callback(err, dbinfo.instance);
        };
      })(this));
    };


    /*
     * Tests if the given DB class exists in @registry
     */

    JsDbLoader.prototype.exists = function(name) {
      if (this.registry[name] != null) {
        return true;
      }
      return false;
    };


    /*
     * Returns an instance from the list
     */

    JsDbLoader.prototype.get = function(name) {
      if (this.instances[name] != null) {
        return this.instances[name];
      }
    };


    /*
     * Creates a new instance of the given `name` database.
     * If the database name doesn't exist in @registry, an error is thrown.
     */

    JsDbLoader.prototype.getDbInstance = function(name) {
      var db, instance, object;
      db = this.registry[name];
      if (db == null) {
        throw Error("JsDb doesn't have " + name + " registered");
      }
      if (typeof db === 'string') {
        object = window.App.loadClass(db);
      } else {
        object = db;
      }
      instance = new object();
      this.instances[name] = instance;
      return instance;
    };

    return JsDbLoader;

  })();

}).call(this);
